import { render, staticRenderFns } from "./RoundCardHeader.vue?vue&type=template&id=769323f6&"
import script from "./RoundCardHeader.vue?vue&type=script&lang=js&"
export * from "./RoundCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports